import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { toFormatDate } from '../../utils/date';

interface NoteItemProps {
    note: any;
}

const NoteItem: React.FC<NoteItemProps> = ({ note }) => {
    const t = useTranslate();
    const createdAt: string | undefined = note?.createdAt;

    const title =
        note?.data?.customFields?.forms?._note_?.title ||
        note?.data?.text ||
        note?.data?.title ||
        note?.name ||
        t('ra.action.show');

    const author = note?.data?.auth?.username || note?.data?.auth?.firstName || note?.data?.username || '';

    const formattedDate = createdAt ? toFormatDate(createdAt, 'DD/MM/YYYY HH:mm:ss') : '';

    return (
        <Box style={{ background: 'white', padding: 8, borderRadius: 4 }}>
            <Box display='grid' gridTemplateColumns='auto 1fr' gridGap={8} alignItems='start'>
                <Box style={{ display: 'flex', alignItems: 'center', height: 24 }}>
                    <MoreHorizIcon fontSize='small' color='primary' />
                </Box>
                <Box>
                    <Typography variant='subtitle2' style={{ fontWeight: 600 }}>
                        {title || '-'}
                    </Typography>
                    <Typography variant='caption' color='textSecondary'>
                        {formattedDate}
                        {author ? ` · ${t('app.objects.by') || 'Par'} ${author}` : ''}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default NoteItem;
